<template>
  <ul class="navbar__nav">
    <li>
      <RouterLink :to="t('routes.account.path')" class="navbar__navlink">{{ t('routes.account.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.coproperty.path')" class="navbar__navlink">{{ t('routes.coproperty.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.syndicate.path')" class="navbar__navlink">{{ t('routes.syndicate.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.invoices.path')" class="navbar__navlink">{{ t('routes.invoices.name') }}</RouterLink>
    </li>
    <li>
      <RouterLink :to="t('routes.activities.path')" class="navbar__navlink">{{ t('routes.activities.name') }}</RouterLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { useI18n } from "vue3-i18n";

const {t} = useI18n()
</script>
